/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Form, Input, Modal } from 'antd';

import './ModalStyle.scss';

function ExportTaskListEmailModal({
  isVisible,
  setIsVisible,
  onConfirm,
  defaultEmail,
  loading,
  canEditEmail = true,
}) {
  const [email, setEmail] = useState(defaultEmail || '');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    setEmail(defaultEmail || '');
    form.setFieldsValue({ email: defaultEmail || '' });
  }, [defaultEmail, isVisible]);

  const handleOk = async () => {
    try {
      setIsSubmitting(true);
      await form.validateFields();
      await onConfirm(email);
      setIsVisible(false);
    } catch (e) {
      // erro de validação, não fecha
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      open={isVisible}
      title="Exportar Relatório por E-mail"
      onOk={handleOk}
      onCancel={() => setIsVisible(false)}
      okText="Solicitar Exportação"
      cancelText="Cancelar"
      width={400}
      className="training-list-confirmation-modal"
      okButtonProps={{
        style: {
          backgroundColor: '#5cb85c',
          color: 'white',
          border: 'none',
        },
        loading: isSubmitting || loading,
        disabled: isSubmitting || loading,
      }}
      cancelButtonProps={{ disabled: isSubmitting || loading }}
      closable={!isSubmitting && !loading}
      maskClosable={!isSubmitting && !loading}
    >
      <p style={{ marginBottom: 16 }}>
        O relatório será gerado e, quando estiver pronto, será enviado para o e-mail informado
        abaixo.
      </p>
      <Form form={form} layout="vertical" initialValues={{ email: defaultEmail }}>
        <Form.Item
          label="E-mail para envio"
          name="email"
          rules={[
            { required: true, message: 'Por favor, informe o e-mail.' },
            { type: 'email', message: 'E-mail inválido.' },
          ]}
        >
          <Input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Digite o e-mail para envio do relatório"
            autoFocus={canEditEmail}
            disabled={!canEditEmail || isSubmitting || loading}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default ExportTaskListEmailModal;
